module.exports = __webpack_public_path__ + "static/img/19.40e935b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/19.jpg
// module id = VbRn
// module chunks = 0